__turbopack_context__.v({
  "messageIcon": "styles-module__HwmAGa__messageIcon",
  "messageIconWrapper": "styles-module__HwmAGa__messageIconWrapper",
});
